import { render } from "./DurataStazione.vue?vue&type=template&id=70dfdcd6&scoped=true"
import script from "./DurataStazione.vue?vue&type=script&lang=js"
export * from "./DurataStazione.vue?vue&type=script&lang=js"

import "./DurataStazione.vue?vue&type=style&index=0&id=70dfdcd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dfdcd6"]])

export default __exports__